import {store} from "../store/store";
import axios from "axios"
import moment from 'moment'
import jwt from "jsonwebtoken";

function parse_project_response(resp_data) {
  var project = resp_data.project;

  // #385 default to previous 2 weeks - yesterday
  if (!project.timeframe_start) {
      console.log("project.service parse_project_response no project timeframe_start, setting default to now-two weeks");
      var two_weeks_ago = moment().subtract(2, 'weeks')
      project.timeframe_start = moment.utc(two_weeks_ago.format("MM-DD-YYYY") + " 00:00", "MM-DD-YYYY HH:mm").toISOString();
  }
  if (!project.timeframe_end) {
      console.log("project_service parse_project_response no project timeframe_end, setting default to yesterday");
      var yesterday = moment().subtract(1, 'days');
      project.timeframe_end = moment.utc(yesterday.format("MM-DD-YYYY") + " 23:59", "MM-DD-YYYY HH:mm").toISOString();
  }

  return project;
}

export const getAvailableDomains = () => {
    // TODO, how to handle this for admin, where there are not all domains listed in token
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/iam/v1/domains`, {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        }).then(resp => {
            if (resp.data) {
              return resp.data.domains.map(d => {
                return {
                  "id": d.id,
                  "name": d.name,
                }
              });
            }
            else {
              return [];
            }
        }).catch(err => {
          console.log("Error during getAvailableDomains call");
          console.log(err);
        });
    });
};

export const projectCan = (action, domain_id, resource) => {
          // guard function to decide whether a given action can be perforrmed
          // given current access token.
          var decoded_token = jwt.decode(store.state.accessToken)
          /* console.log(decoded_token);
          console.log('DEBUG action: ' + action);
          console.log('DEBUG domain: ' + domain);
          console.log('DEBUG resource: ' + resource);
          */

          for (var role_entry of decoded_token["iam:roles"]) {
            // Check if domain matches.  ADMIN of id 0 matches all
            if ((role_entry["domain_id"] == 0 && role_entry["role"] == "ADMIN")
                || (role_entry["domain_id"] == domain_id)) {
                for (var permission of role_entry["permissions"]) {
                    // Check for action match
                    if (permission["action"] == "pernilla:*"
                        || permission["action"] == "pernilla" + action) {
                        // check resource match
                        if ( permission["resource"] == "*"
                           || permission["resource"] == resource) {
                              //console.log('DEBUG permitted');
                              return true;
                        }
                    }
                }
            }

          }
          //console.log('DEBUG forbidden');
          return false;

}

export const updateProject = (id, data) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.patch(`/projects/${id}`, JSON.stringify(data), {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        }).then(resp => parse_project_response(resp.data))
    })
};
export const addCommunityToProject = (id, data) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.post(`/projects/${id}/communities`, JSON.stringify(data), {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        })
            .then(resp => {
               return resp.data.community
            })
            .catch(err => err)
    })
};
export const updateCommunityInProject = (pid, cid, data) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.patch(`/projects/${pid}/communities/${cid}`, JSON.stringify(data), {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        })
            .then(resp => {
               return resp.data.communities;
            })
            //.catch(err => err)
    })
};
export const lockCommunityInProject = (pid, cid) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.put(`/projects/${pid}/communities/${cid}/lock`, JSON.stringify(null), {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        })
        .then(resp => {
             console.log("project.service lockCommunityInProject then");
             return resp.data.community;
        }).catch(err => {
          console.log(err);
        })
    })
};
export const unlockCommunityInProject = (pid, cid) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.delete(`/projects/${pid}/communities/${cid}/lock`, {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        })
        .then(resp => {
             console.log("project.service unlockCommunityInProject then");
             return resp.data.community;
        }).catch(err => {
          console.log(err);
        })
    })
};
export const deleteCommunityFromProject = (projectId, communityId) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.delete(`/projects/${projectId}/communities/${communityId}`,
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }).then(resp => resp.data.communities).catch(err => err)
    })
};
export const getProject = id => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/projects/${id}`,
            {
                headers: {Authorization: "Bearer " + token}
            }).then(resp => parse_project_response(resp.data)).catch(err => err);
    })
};
export const getDependantAnalyses = (pid, cid) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/projects/${pid}/communities/${cid}/dependant_analyses`, {
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": 'application/json'
            }
        })
            .then(resp => {
               return resp.data.analyses;
            })
    })
}

export const isRoomUser = () => {
    // Utility for checking if given user has RoomUser role
    var decoded_token = jwt.decode(store.state.accessToken)

    for (var role_entry of decoded_token["iam:roles"]) {
      if ( role_entry["role"] == "RoomUser") {
        return true;
      }
    }
    return false;
}
